module.exports = __webpack_public_path__ + "img/p99.5b58932f.png";